﻿function showRequisiteHistoryWindowFactory() {
    const wnd = document.createElement('div');
    document.body.appendChild(wnd);

    const instancePopup = $(wnd)
        .kendoWindow({
            visible: false,
            pinned: true,
            modal: true,
            actions: ['Close']
        })
        .data('kendoWindow');

    return ({ sender: { element } }: kendo.ui.ButtonClickEvent) => {
        if (instancePopup) {
            const localeDict = window.getLocaleDict().staticRequisiteHistory;
            instancePopup.title(localeDict.historyTitle.replace('{0}', element.data('title')));
            instancePopup.center().open().refresh(element.data('url'));
        }
    };
}

window.showRequisiteHistoryWindow = showRequisiteHistoryWindowFactory();
